import React from "react";
import LogsContainer from "../../container/admin/logs-container/LogsContainer";

const Logs = () => {
    return <LogsContainer />;
};

export default Logs; 